export const environment = {
  production: false,
  backendUrl: 'https://apphubtst.portoseguro.brasil'
  //backendUrl: 'https://ressarcimento-propostas-app-tst-psg-juridico-recupera.apps.ocpnpr.portoseguro.brasil'
};